module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/mc-complex.c097a3a7.png";